import * as common from './common.json';
import * as plans from './plans.json';

export const en = {
  common,
  plans,
};
